module.exports = __webpack_public_path__ + "img/2027.c0478ece.jpg";